// extracted by mini-css-extract-plugin
export default {"images_profile":"home_images_profile__QGk7h","col_md_2_custom":"home_col_md_2_custom__2zfZh","position_bottom":"home_position_bottom__R5ZKE"};